function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _window;
function cov_1m19cjiy8h() {
  var path = "/app/src/services/mobile-bridge.ts";
  var hash = "a519ae63938812b1551443ab1d09e89b5e7d5aac";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/services/mobile-bridge.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 30
        },
        end: {
          line: 8,
          column: 10
        }
      },
      "1": {
        start: {
          line: 15,
          column: 25
        },
        end: {
          line: 15,
          column: 28
        }
      },
      "2": {
        start: {
          line: 17,
          column: 27
        },
        end: {
          line: 17,
          column: 58
        }
      },
      "3": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 24,
          column: 30
        }
      },
      "4": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 45
        }
      },
      "5": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 41
        }
      },
      "6": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 75
        }
      },
      "7": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 45,
          column: 6
        }
      },
      "8": {
        start: {
          line: 49,
          column: 22
        },
        end: {
          line: 49,
          column: 39
        }
      },
      "9": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 63,
          column: 5
        }
      },
      "10": {
        start: {
          line: 52,
          column: 29
        },
        end: {
          line: 52,
          column: 49
        }
      },
      "11": {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 54
        }
      },
      "12": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 50
        }
      },
      "13": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 59
        }
      },
      "14": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 59
        }
      },
      "15": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 72,
          column: 6
        }
      },
      "16": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 83,
          column: 6
        }
      },
      "17": {
        start: {
          line: 87,
          column: 24
        },
        end: {
          line: 120,
          column: 5
        }
      },
      "18": {
        start: {
          line: 89,
          column: 20
        },
        end: {
          line: 89,
          column: 49
        }
      },
      "19": {
        start: {
          line: 90,
          column: 40
        },
        end: {
          line: 92,
          column: 9
        }
      },
      "20": {
        start: {
          line: 94,
          column: 8
        },
        end: {
          line: 102,
          column: 9
        }
      },
      "21": {
        start: {
          line: 95,
          column: 37
        },
        end: {
          line: 97,
          column: 11
        }
      },
      "22": {
        start: {
          line: 99,
          column: 10
        },
        end: {
          line: 99,
          column: 49
        }
      },
      "23": {
        start: {
          line: 101,
          column: 10
        },
        end: {
          line: 101,
          column: 17
        }
      },
      "24": {
        start: {
          line: 104,
          column: 8
        },
        end: {
          line: 108,
          column: 11
        }
      },
      "25": {
        start: {
          line: 105,
          column: 10
        },
        end: {
          line: 107,
          column: 31
        }
      },
      "26": {
        start: {
          line: 106,
          column: 12
        },
        end: {
          line: 106,
          column: 41
        }
      },
      "27": {
        start: {
          line: 110,
          column: 8
        },
        end: {
          line: 118,
          column: 11
        }
      },
      "28": {
        start: {
          line: 111,
          column: 33
        },
        end: {
          line: 111,
          column: 60
        }
      },
      "29": {
        start: {
          line: 113,
          column: 10
        },
        end: {
          line: 117,
          column: 11
        }
      },
      "30": {
        start: {
          line: 114,
          column: 12
        },
        end: {
          line: 114,
          column: 64
        }
      },
      "31": {
        start: {
          line: 116,
          column: 12
        },
        end: {
          line: 116,
          column: 46
        }
      },
      "32": {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 122,
          column: 23
        }
      },
      "33": {
        start: {
          line: 126,
          column: 19
        },
        end: {
          line: 126,
          column: 31
        }
      },
      "34": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 128,
          column: 68
        }
      },
      "35": {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 130,
          column: 29
        }
      },
      "36": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 136,
          column: 5
        }
      },
      "37": {
        start: {
          line: 135,
          column: 6
        },
        end: {
          line: 135,
          column: 16
        }
      },
      "38": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 149,
          column: 5
        }
      },
      "39": {
        start: {
          line: 139,
          column: 25
        },
        end: {
          line: 139,
          column: 41
        }
      },
      "40": {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 141,
          column: 28
        }
      },
      "41": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 60
        }
      },
      "42": {
        start: {
          line: 146,
          column: 6
        },
        end: {
          line: 146,
          column: 60
        }
      },
      "43": {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 148,
          column: 16
        }
      },
      "44": {
        start: {
          line: 153,
          column: 28
        },
        end: {
          line: 153,
          column: 46
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 48
          },
          end: {
            line: 32,
            column: 3
          }
        },
        line: 28
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 34,
            column: 3
          }
        },
        loc: {
          start: {
            line: 34,
            column: 58
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 34
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 54
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 38
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        },
        loc: {
          start: {
            line: 48,
            column: 67
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 48
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        loc: {
          start: {
            line: 66,
            column: 53
          },
          end: {
            line: 73,
            column: 3
          }
        },
        line: 66
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 3
          }
        },
        loc: {
          start: {
            line: 75,
            column: 49
          },
          end: {
            line: 84,
            column: 3
          }
        },
        line: 75
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 86,
            column: 2
          },
          end: {
            line: 86,
            column: 3
          }
        },
        loc: {
          start: {
            line: 86,
            column: 21
          },
          end: {
            line: 123,
            column: 3
          }
        },
        line: 86
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 88,
            column: 7
          }
        },
        loc: {
          start: {
            line: 88,
            column: 27
          },
          end: {
            line: 119,
            column: 7
          }
        },
        line: 88
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 104,
            column: 40
          },
          end: {
            line: 104,
            column: 41
          }
        },
        loc: {
          start: {
            line: 104,
            column: 46
          },
          end: {
            line: 108,
            column: 9
          }
        },
        line: 104
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 105,
            column: 43
          },
          end: {
            line: 105,
            column: 44
          }
        },
        loc: {
          start: {
            line: 105,
            column: 49
          },
          end: {
            line: 107,
            column: 11
          }
        },
        line: 105
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 110,
            column: 43
          },
          end: {
            line: 110,
            column: 44
          }
        },
        loc: {
          start: {
            line: 110,
            column: 54
          },
          end: {
            line: 118,
            column: 9
          }
        },
        line: 110
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 125,
            column: 2
          },
          end: {
            line: 125,
            column: 3
          }
        },
        loc: {
          start: {
            line: 125,
            column: 31
          },
          end: {
            line: 131,
            column: 3
          }
        },
        line: 125
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 133,
            column: 2
          },
          end: {
            line: 133,
            column: 3
          }
        },
        loc: {
          start: {
            line: 133,
            column: 41
          },
          end: {
            line: 150,
            column: 3
          }
        },
        line: 133
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 24,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 38
          }
        }, {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 26
          }
        }, {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 42
          }
        }, {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 24,
            column: 30
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 48,
            column: 31
          },
          end: {
            line: 48,
            column: 65
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 48,
            column: 63
          },
          end: {
            line: 48,
            column: 65
          }
        }],
        line: 48
      },
      "2": {
        loc: {
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 102,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 102,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 94
      },
      "3": {
        loc: {
          start: {
            line: 113,
            column: 10
          },
          end: {
            line: 117,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 10
          },
          end: {
            line: 117,
            column: 11
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 113
      },
      "4": {
        loc: {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 136,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 136,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 134
      },
      "5": {
        loc: {
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 134,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 134,
            column: 13
          }
        }, {
          start: {
            line: 134,
            column: 17
          },
          end: {
            line: 134,
            column: 41
          }
        }],
        line: 134
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a519ae63938812b1551443ab1d09e89b5e7d5aac"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1m19cjiy8h = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1m19cjiy8h();
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { MOBILE_BRIDGE_QUERY_PARAM_NAME } from 'src/constants/common';
import { dataDog } from 'src/utils/datadog/data-dog';
var MOBILE_BRIDGE_ACTIONS = (cov_1m19cjiy8h().s[0]++, {
  INITIALIZATION_DATA: 'initializationData',
  ON_CHANGE_DIMENSIONS: 'onChangeDimensions',
  ON_LEARN_MORE_CLICKED: 'onLearnMoreClicked'
});
var AWAITING_TIMEOUT = (cov_1m19cjiy8h().s[1]++, 500);
var iosMessageHandlers = (cov_1m19cjiy8h().s[2]++, (_window = window) === null || _window === void 0 || (_window = _window.webkit) === null || _window === void 0 ? void 0 : _window.messageHandlers);
var MobileBridge = /*#__PURE__*/function () {
  function MobileBridge() {
    var _window2, _window3;
    _classCallCheck(this, MobileBridge);
    _defineProperty(this, "mobileBridgeBus", (cov_1m19cjiy8h().s[3]++, (cov_1m19cjiy8h().b[0][0]++, iosMessageHandlers === null || iosMessageHandlers === void 0 ? void 0 : iosMessageHandlers.tabbyMobileSDK) || (cov_1m19cjiy8h().b[0][1]++, (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.tabbyMobileSDK) || (cov_1m19cjiy8h().b[0][2]++, iosMessageHandlers === null || iosMessageHandlers === void 0 ? void 0 : iosMessageHandlers.ReactNativeWebView) || (cov_1m19cjiy8h().b[0][3]++, (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.ReactNativeWebView)));
    _defineProperty(this, "timeoutTimerID", void 0);
  }
  return _createClass(MobileBridge, [{
    key: "sendDimensions",
    value: function sendDimensions(dimensions) {
      cov_1m19cjiy8h().f[0]++;
      cov_1m19cjiy8h().s[4]++;
      // this.mobileBridgeBus?.postMessage(JSON.stringify(dimensions), '*');
      this.sendDimensionsToAndroid(dimensions);
      cov_1m19cjiy8h().s[5]++;
      this.sendDimensionsToIOS(dimensions);
    }
  }, {
    key: "sendDimensionsToAndroid",
    value: function sendDimensionsToAndroid(dimensions) {
      var _this$mobileBridgeBus, _this$mobileBridgeBus2;
      cov_1m19cjiy8h().f[1]++;
      cov_1m19cjiy8h().s[6]++;
      (_this$mobileBridgeBus = this.mobileBridgeBus) === null || _this$mobileBridgeBus === void 0 || (_this$mobileBridgeBus2 = _this$mobileBridgeBus.onChangeDimensions) === null || _this$mobileBridgeBus2 === void 0 || _this$mobileBridgeBus2.call(_this$mobileBridgeBus, JSON.stringify(dimensions));
    }
  }, {
    key: "sendDimensionsToIOS",
    value: function sendDimensionsToIOS(dimensions) {
      var _this$mobileBridgeBus3, _this$mobileBridgeBus4;
      cov_1m19cjiy8h().f[2]++;
      cov_1m19cjiy8h().s[7]++;
      // iOS and flutter have same contract
      (_this$mobileBridgeBus3 = this.mobileBridgeBus) === null || _this$mobileBridgeBus3 === void 0 || (_this$mobileBridgeBus4 = _this$mobileBridgeBus3.postMessage) === null || _this$mobileBridgeBus4 === void 0 || _this$mobileBridgeBus4.call(_this$mobileBridgeBus3, JSON.stringify({
        type: MOBILE_BRIDGE_ACTIONS.ON_CHANGE_DIMENSIONS,
        data: dimensions
      }));
    }
  }, {
    key: "openPage",
    value: function openPage(url) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1m19cjiy8h().b[1][0]++, {});
      cov_1m19cjiy8h().f[3]++;
      var markedUrl = (cov_1m19cjiy8h().s[8]++, this.markUrl(url));
      cov_1m19cjiy8h().s[9]++;
      try {
        var serializedData = (cov_1m19cjiy8h().s[10]++, JSON.stringify(data));
        cov_1m19cjiy8h().s[11]++;
        this.openPageAndroid(serializedData, markedUrl);
        cov_1m19cjiy8h().s[12]++;
        this.openPageIOS(serializedData, markedUrl);

        // this.mobileBridgeBus?.postMessage(serializedPayload, '*');
      } catch (error) {
        cov_1m19cjiy8h().s[13]++;
        // eslint-disable-next-line no-console
        console.error('MobileBridge serialize error', error);
        cov_1m19cjiy8h().s[14]++;
        dataDog.error('MobileBridge serialize error', error);
      }
    }
  }, {
    key: "openPageAndroid",
    value: function openPageAndroid(data, url) {
      var _this$mobileBridgeBus5, _this$mobileBridgeBus6;
      cov_1m19cjiy8h().f[4]++;
      cov_1m19cjiy8h().s[15]++;
      (_this$mobileBridgeBus5 = this.mobileBridgeBus) === null || _this$mobileBridgeBus5 === void 0 || (_this$mobileBridgeBus6 = _this$mobileBridgeBus5.onLearnMoreClicked) === null || _this$mobileBridgeBus6 === void 0 || _this$mobileBridgeBus6.call(_this$mobileBridgeBus5, JSON.stringify({
        url: url,
        data: data
      }));
    }
  }, {
    key: "openPageIOS",
    value: function openPageIOS(data, url) {
      var _this$mobileBridgeBus7, _this$mobileBridgeBus8;
      cov_1m19cjiy8h().f[5]++;
      cov_1m19cjiy8h().s[16]++;
      // iOS and flutter have same contract
      (_this$mobileBridgeBus7 = this.mobileBridgeBus) === null || _this$mobileBridgeBus7 === void 0 || (_this$mobileBridgeBus8 = _this$mobileBridgeBus7.postMessage) === null || _this$mobileBridgeBus8 === void 0 || _this$mobileBridgeBus8.call(_this$mobileBridgeBus7, JSON.stringify({
        type: MOBILE_BRIDGE_ACTIONS.ON_LEARN_MORE_CLICKED,
        url: url,
        data: data
      }));
    }
  }, {
    key: "awaitData",
    value: function awaitData() {
      var _this = this;
      cov_1m19cjiy8h().f[6]++;
      var dataAwaiter = (cov_1m19cjiy8h().s[17]++, new Promise(function (resolve, reject) {
        cov_1m19cjiy8h().f[7]++;
        var url = (cov_1m19cjiy8h().s[18]++, new URL(window.location.href));
        var isURLContainsInitParams = (cov_1m19cjiy8h().s[19]++, url.searchParams.has(MOBILE_BRIDGE_ACTIONS.INITIALIZATION_DATA));
        cov_1m19cjiy8h().s[20]++;
        if (isURLContainsInitParams) {
          cov_1m19cjiy8h().b[2][0]++;
          var initializationData = (cov_1m19cjiy8h().s[21]++, _this.parseData(url.searchParams.get(MOBILE_BRIDGE_ACTIONS.INITIALIZATION_DATA)));
          cov_1m19cjiy8h().s[22]++;
          resolve(initializationData.parsedData);
          cov_1m19cjiy8h().s[23]++;
          return;
        } else {
          cov_1m19cjiy8h().b[2][1]++;
        }
        cov_1m19cjiy8h().s[24]++;
        window.addEventListener('load', function () {
          cov_1m19cjiy8h().f[8]++;
          cov_1m19cjiy8h().s[25]++;
          _this.timeoutTimerID = setTimeout(function () {
            cov_1m19cjiy8h().f[9]++;
            cov_1m19cjiy8h().s[26]++;
            reject(new Error('timeout'));
          }, AWAITING_TIMEOUT);
        });
        cov_1m19cjiy8h().s[27]++;
        window.addEventListener('message', function (event) {
          cov_1m19cjiy8h().f[10]++;
          var _ref = (cov_1m19cjiy8h().s[28]++, _this.parseData(event === null || event === void 0 ? void 0 : event.data)),
            parsedData = _ref.parsedData;
          cov_1m19cjiy8h().s[29]++;
          if ((parsedData === null || parsedData === void 0 ? void 0 : parsedData.type) === MOBILE_BRIDGE_ACTIONS.INITIALIZATION_DATA) {
            cov_1m19cjiy8h().b[3][0]++;
            cov_1m19cjiy8h().s[30]++;
            resolve(_this.parseData(parsedData.data).parsedData);
            cov_1m19cjiy8h().s[31]++;
            clearTimeout(_this.timeoutTimerID);
          } else {
            cov_1m19cjiy8h().b[3][1]++;
          }
        });
      }));
      cov_1m19cjiy8h().s[32]++;
      return dataAwaiter;
    }
  }, {
    key: "markUrl",
    value: function markUrl(url) {
      cov_1m19cjiy8h().f[11]++;
      var newUrl = (cov_1m19cjiy8h().s[33]++, new URL(url));
      cov_1m19cjiy8h().s[34]++;
      newUrl.searchParams.append(MOBILE_BRIDGE_QUERY_PARAM_NAME, '1');
      cov_1m19cjiy8h().s[35]++;
      return newUrl.toString();
    }
  }, {
    key: "parseData",
    value: function parseData(data) {
      cov_1m19cjiy8h().f[12]++;
      cov_1m19cjiy8h().s[36]++;
      if ((cov_1m19cjiy8h().b[5][0]++, !data) || (cov_1m19cjiy8h().b[5][1]++, typeof data !== 'string')) {
        cov_1m19cjiy8h().b[4][0]++;
        cov_1m19cjiy8h().s[37]++;
        return {};
      } else {
        cov_1m19cjiy8h().b[4][1]++;
      }
      cov_1m19cjiy8h().s[38]++;
      try {
        var parsedData = (cov_1m19cjiy8h().s[39]++, JSON.parse(data));
        cov_1m19cjiy8h().s[40]++;
        return {
          parsedData: parsedData
        };
      } catch (error) {
        cov_1m19cjiy8h().s[41]++;
        // eslint-disable-next-line no-console
        console.error('MobileBridge parse data error', error);
        cov_1m19cjiy8h().s[42]++;
        dataDog.error('MobileBridge parse data error', error);
        cov_1m19cjiy8h().s[43]++;
        return {};
      }
    }
  }]);
}();
export var mobileBridge = (cov_1m19cjiy8h().s[44]++, new MobileBridge());